<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row class="subtitle-2 text--primary"> </v-row>

        <!-- manifest list -->
        <v-row class="subtitle-2 text--primary mb-2">
          <v-col cols="8">
            <div>
              Invoice No:
              <span>{{ invoiceItem && invoiceItem.DocNum }}</span>
            </div>
            <div>
              Customer:
              <span style="color: red">{{
                invoiceItem.ocrd && invoiceItem.ocrd.Name
              }}</span>
            </div>
            <div>
              Phone Number:
              <span style="color: red">{{
                invoiceItem.ocrd && invoiceItem.ocrd.PhoneNumber
              }}</span>
            </div>
            <div>
              Lines:
              {{ manifestData && manifestData.Lines }}
            </div>
            <div>
              Line Cost:
              {{ manifestData && manifestData.LineCost.toLocaleString() }}
            </div>
          </v-col>

          <v-col cols="4">
            <div>
              Container No:
              <span style="color: red">{{
                manifestData.cargo && manifestData.cargo.Name
              }}</span>
            </div>
            <div>
              Date:
              <span style="color: red">{{
                invoiceItem && invoiceItem.DocDate
              }}</span>
            </div>

            <v-btn text @click="generateInvoice()" color="primary">
              <v-icon color="black" left>mdi-printer</v-icon> Generate Invoice
            </v-btn>
            <v-btn text @click="generateDelivery()" color="accent">
              <v-icon color="black" left>mdi-printer</v-icon> Print Delivery
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row class="mt-2">
          <v-col cols="12">
            <v-btn @click.native="dialog = true" small color="primary">
              <v-icon left>mdi-plus</v-icon>Receive Payment
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-2 subtitle-2 text--primary">
          <v-col cols="12" md="8">
            <v-data-table
              :headers="headers"
              :items="invoiceArray"
              :mobile-breakpoint="0"
              hide-default-footer
            >
              <!-- action template -->
              <template v-slot:item.LineTotal="{ item }">
                {{ item.LineTotal && item.LineTotal.toLocaleString() }}
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.Price="{ item }">
                {{ item.Price && item.Price.toLocaleString() }}
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>

          <v-col cols="12" md="4">
            <div>
              Invoice Total:
              {{
                invoiceItem.DocTotal && invoiceItem.DocTotal.toLocaleString()
              }}
            </div>

            <div>
              Total Paid:
              {{ invoiceItem.PaidSum && invoiceItem.PaidSum.toLocaleString() }}
            </div>

            <div>
              Balance:
              <span style="color: red">
                {{
                  invoiceItem.Balance && invoiceItem.Balance.toLocaleString()
                }}
              </span>
            </div>

            <div class="mt-2 float-right">
              <h3
                v-show="parseInt(invoiceItem.Balance) <= 0"
                style="color: green; font-weight: bold"
              >
                <v-icon color="green">mdi-check</v-icon> Cleared
              </h3>
              <h3
                v-show="invoiceItem.Balance > 0"
                style="color: red; font-weight: bold"
              >
                <v-icon color="red">mdi-alert-outline</v-icon> Not Fully Paid
              </h3>
            </div>
          </v-col>
        </v-row>

        <!-- clearing debt dialog -->
        <v-dialog v-model="dialog" max-width="700px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Record Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="subtitle-2 text--primary">
                  <v-col cols="12"
                    >Customer:
                    {{ invoiceItem.ocrd && invoiceItem.ocrd.Name }}</v-col
                  >
                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="amount"
                      label="Amount Paid"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6" sm="6">
                    <v-autocomplete
                      autocomplete="off"
                      dense
                      outlined
                      v-model="accountId"
                      :items="accounts"
                      label="Payment Mode"
                      item-text="Name"
                      item-value="id"
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="PaymentRemarks"
                      label="Ref No / Remarks"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6" sm="6">
                    <DatePicker
                      @date="setDate"
                      :myDate="date"
                      :title="`Date`"
                    ></DatePicker>
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      color="accent"
                      @click="savePayment"
                      :loading="loader"
                    >
                      <v-icon left>mdi-content-save</v-icon>Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-card>
        </v-dialog>
        <!-- end -->

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Payments</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="paymentHeaders"
              :items="payments"
              :mobile-breakpoint="0"
              hide-default-footer
            >
              <!-- action template -->
              <template v-slot:item.SumApplied="{ item }">
                {{ item.SumApplied && item.SumApplied.toLocaleString() }}
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- summary dialog -->
    <v-dialog
      v-model="pdfDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary" dense>
          <v-toolbar-title>
            <v-btn icon dark @click.native="pdfDialog = false">
              <v-icon dark>mdi-keyboard-backspace</v-icon>
            </v-btn>
            Print Document
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="pdfDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container class="docForm">
            <v-row justify="center">
              <v-col cols="10">
                <iframe :src="pdfDoc" width="100%" height="800px"></iframe>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end -->

    <pdf-preview ref="pdfpreview"></pdf-preview>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import jsPDF from "jspdf";
import "jspdf-autotable";
// import { generatePdf } from "@/common/freightinvoice.js";
export default {
  components: {},
  props: {
    invoiceItem: {
      type: Object,
    },
    manifestData: {
      type: Object,
    },
    invoiceArray: {
      type: Array,
    },
    payments: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters(["user"]),
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  data: () => ({
    dataItem: {},
    pdfDialog: false,
    genSettings: {},
    pdfDoc: null,
    dialog: false,
    accountId: null,
    PaymentRemarks: null,
    amount: null,
    accounts: [],
    loader: false,
    activeItem: {},
    Description: null,
    search: null,
    date: new Date().toISOString().substr(0, 10),
    docCreate: false,
    headers: [
      { text: "Qty", value: "Quantity" },
      { text: "Description", value: "Description" },
      // { text: "Price", value: "Price" },
      // { text: "Total", value: "LineTotal" },
    ],
    paymentHeaders: [
      { text: "Account", value: "oact.Name" },
      { text: "Amount", value: "SumApplied" },
      { text: "Ref No / Remarks", value: "PaymentRemarks" },
      // { text: "Date", value: "created_at" },
      { text: "Received By", value: "receivedby.name" },
    ],
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    generateDelivery() {
      const title = "Delivery Note";
      this.generatePdf(title);
    },
    generateInvoice() {
      const title = "Sales Invoice";
      this.generatePdf(title);
    },
    setDate(date) {
      this.date = date;
    },
    savePayment() {
      if (
        (this.date == null || this.date == undefined) &&
        this.dateReadonly == "N"
      ) {
        this.$refs.snackbar.show("Please select date!", "red");
      } else {
        const self = this;

        const data = {
          CardCode: self.invoiceItem.ocrd.id,
          DocDate: self.date,
          o_a_c_t_s_id: self.accountId,
          SumApplied: self.amount,
          PaymentRemarks: self.PaymentRemarks,
          container_id: self.manifestData.store_id,
        };
        if (this.accountId == null || this.amount == null) {
          this.$refs.snackbar.show("Account or amount missing!", "red");
        } else {
          const url = "/incoming-payments";
          this.loader = true;
          this.$store
            .dispatch("post", { url, data })
            .then((res) => {
              if (res.ResultCode == 1200) {
                self.loader = false;
                location.reload();
              } else {
                self.loader = false;
                this.$refs.snackbar.show(res.ResultDesc, "red");
              }
            })
            .catch((err) => {
              self.loader = false;
              this.$refs.snackbar.show(err, "red");
            });
        }
      }
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.genSettings = { ...res.ResponseData };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    generatePdf(title) {
      /**
       * Load Document For printing
       */
      // this.$store.commit("btnLoader", true);

      const record = this.invoiceItem;
      const tableData = this.invoiceArray;
      const objectType = 14;

      const TaxRate = `${this.genSettings.CurrentTax} %`;

      const TaxPct = this.genSettings.CurrentTax;

      const phones = this.genSettings.CompanyPhone.split(",");

      var doc = new jsPDF({ compress: true });

      var objectName = title;

      doc.setFont("Georgia, serif", "bold");
      doc.setFontSize(16);
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      var totalPagesExp = "{total_pages_count_string}";

      /*
          Constnats
      */
      const textFontSize = 11;
      //const tableTextFontSize = 10;
      /*
      LOGO
    */
      // var img = new Image();
      // img.src = require("@/assets/fairland-header.jpeg");
      // doc.addImage(img, "png", 0, 25, pageWidth - 20, 30);

      doc.text(objectName, pageWidth / 2, 10, "center");
      doc.line(5, 11, pageWidth - 5, 11); // Top Line
      doc.setFontSize(10);

      //   doc.text("Original", pageWidth - 20, 14);

      doc.setFontSize(10);

      /*
    -------------------------------------------------------------------------------
                  BEGINNING OF CUSTOMER DETAILS AND DOCUMENT DETAILS
     -----------------------------------------------------------------------------
    */

      /**
       * Customer Details
       */
      doc.addFont("Tahoma");
      doc.setFont("Tahoma", "bold");
      doc.setFontSize(16);

      doc.text(this.storeName, 10, 20);
      doc.setFontSize(11);
      doc.text(this.genSettings.CompanyEmail, 10, 25);
      doc.text(this.genSettings.NotificationEmail, 10, 30);

      doc.text("VAT No: " + this.genSettings.PinNo, pageWidth - 50, 20);
      doc.text("Cell: " + phones[0], pageWidth - 50, 25);
      doc.text(phones[1], pageWidth - 50, 30);

      doc.line(5, 33, pageWidth - 5, 33); // Top Line

      doc.setFontSize(11);

      doc.text("Customer: " + record.ocrd.Name, 10, 40);
      doc.text("Date: " + record.DocDate, pageWidth - 50, 40);

      if (objectType == 14) {
        doc.text("Invoice No: " + record.DocNum, 10, 45);
      }

      if (objectType == 30) {
        doc.text("Quote No: " + record.DocNum, 10, 45);
      }

      doc.setFontSize(textFontSize);

      function headRowsItemDetails() {
        return [
          {
            count: "",
            description: "ITEM",
            Quantity: "QUANTITY",
            Price: "UNIT PRICE",
            total_amount: "AMOUNT",
            TaxRate: "TAX",
          },
        ];
      }

      /*
    -------------------------------------------------------------------------------
                  BEGINNING OF ITEM DETAILS
     -----------------------------------------------------------------------------
    */
      const repeatText = " ";
      const embedText = repeatText.repeat(1800);

      const itemDetails = [];
      for (const note of tableData) {
        const i = tableData.indexOf(note);
        const itemDetail = {
          count: i + 1,
          description: note.Description + embedText,
          Quantity: note.Quantity.toLocaleString(),
          Price: note.Price.toLocaleString(),
          total_amount: note.LineTotal.toLocaleString(),
          TaxRate: TaxRate,
        };

        itemDetails.push(itemDetail);
      }

      const comTax = 1 + TaxPct / 100;

      const cTax = TaxPct / 100;

      const taxAmount = (record.DocTotal / comTax) * cTax;

      const subTotalAmount = record.DocTotal - taxAmount;

      const subTotal = {
        Price: "SUB TOTAL",
        total_amount: subTotalAmount.toLocaleString(),
      };

      const taxTotal = {
        Price: "TAX",
        total_amount: taxAmount.toLocaleString(),
      };

      const totalAmount = {
        Price: "TOTAL",
        total_amount: record.DocTotal.toLocaleString(),
      };

      itemDetails.push(subTotal);
      itemDetails.push(taxTotal);
      itemDetails.push(totalAmount);

      doc.autoTable({
        head: headRowsItemDetails(),
        body: itemDetails,
        theme: "grid",
        headStyles: { fillColor: "#808080" },
        bodyStyles: {
          textColor: "#000000",
          fontSize: 12,
        },
        tableWidth: pageWidth - 20,
        columnStyles: {
          total_amount: {
            halign: "left",
            fontStyle: "bold",
          },
          Price: {
            fontStyle: "bold",
          },
          styles: {
            font: "Tahoma",
            fontSize: 12,
          },
        },

        margin: { left: 5 },
        didDrawPage: function (data) {
          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 0);
          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.right, pageHeight - 10);
        },

        startY: 50,
      });

      /*
    -------------------------------------------------------------------------------
                  BEGINNING FOOTER ITEM DETAILS
     -----------------------------------------------------------------------------
    */

      var pageSize = doc.internal.pageSize;
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

      doc.setFontSize(10);
      var footerText = `From consignor in apparent good order and condition ( unless otherwise noted herein ) in total number of packages indicated above stated by consignor specified for transportation subject to all terms from the receipt to the final destinatioon as indicated. delivery of good will only be made on payment of all freight charges.`;
      const footerArray = [];

      const footTextString = {
        count: footerText,
      };
      footerArray.push(footTextString);

      doc.line(5, pageHeight - 78, pageWidth - 5, pageHeight - 78); // Top Line

      function headFooter() {
        return [
          {
            count: "",
          },
        ];
      }

      doc.setFontSize(8);
      doc.autoTable({
        head: headFooter(),
        body: footerArray,
        theme: "plain",
        columnStyles: {
          styles: {
            font: "Tahoma",
            fontSize: 3,
          },
        },
        margin: { left: 10 },
        startY: pageHeight - 85,
      });

      doc.line(5, pageHeight - 60, pageWidth - 5, pageHeight - 60);
      doc.setFontSize(11);
      doc.text("For General Enquiries", 10, pageHeight - 55);
      doc.text("Cell: " + phones[0], 10, pageHeight - 50);

      doc.text(
        "Accounts are due on demand",
        pageWidth / 2,
        pageHeight - 55,
        "center"
      );
      doc.text(
        "Thanks For your business",
        pageWidth / 2,
        pageHeight - 50,
        "center"
      );

      doc.text("For Accounts Enquiries", pageWidth - 50, pageHeight - 55);
      doc.text("Cell: " + phones[1], pageWidth - 50, pageHeight - 50);
      // doc.text("Date: " + record.DocDate, pageWidth - 50, 40);

      // var footerImg = new Image();
      // footerImg.src = require("@/assets/fairland-footer.png");
      // doc.addImage(footerImg, "png", 0, pageHeight - 60, pageWidth, 50);

      this.pdfDoc = doc.output("bloburi");
      this.$refs.pdfpreview.show(doc.output("bloburi"));
    },
  },
  created() {
    this.getAccounts();
    this.getGenSettings();
  },
};
</script>